import React, { useEffect, useState } from 'react';
import { BrowserView } from 'react-device-detect';
import ReactGA from 'react-ga4';
import { useNavigate } from 'react-router';
import { useSearchParams } from 'react-router-dom';
import { object, string } from 'yup';

import { useAlerta } from 'Component/Alerta';
import { AnimacaoAprender } from 'Component/Animacao';
import Form, { Botao, Campo } from 'Component/Form';
import Icone from 'Component/Icone';
import Usuario from 'Interface/Usuarios';
import { login as loginAction } from 'Reducer/Autenticacao';
import api, { useLoginMutation } from 'Service';
import { persistor, useAppDispatch, useAppSelector } from 'Store';

const regras = object({
  email: string().email('Inválido').required('Obrigatório'),
  senha: string().required('Obrigatório'),
});

const Login = (): React.ReactElement => {
  const alerta = useAlerta();
  const navegacao = useNavigate();
  const dispatch = useAppDispatch();
  const usuario = useAppSelector((estado) => estado.autenticacao.usuario);
  const [login] = useLoginMutation();
  const [fadeOut, setFadeOut] = useState<boolean>(false);
  const [searchParams, setSearchParams] = useSearchParams();

  useEffect(() => {
    if (searchParams.get('reset')) {
      dispatch(loginAction({}));
      dispatch(api.util.resetApiState());
      persistor.purge();
      searchParams.delete('reset');
      setSearchParams(searchParams);
    } else {
      if (usuario) {
        navegacao('/intro');
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    if (fadeOut) {
      setTimeout(() => {
        navegacao('/intro');
      }, 500);
    }
  }, [fadeOut, navegacao]);

  const enviar = async (dados: Usuario): Promise<void> => {
    try {
      const resposta = await login(dados).unwrap();

      dispatch(loginAction(resposta));

      setFadeOut(true);

      const som = new Audio('/sound/intro.mp3');
      som.play();

      ReactGA.event('login', { method: 'Estude+' });
    } catch (erro) {
      alerta({
        titulo: 'Atenção',
        conteudo: 'E-mail ou senha inválidos. Tente novamente!',
        tema: 'danger',
      });
    }
  };

  return (
    <div
      className={[
        'bg-black',
        'animate__animated',
        !fadeOut ? 'animate__fadeIn' : 'animate__fadeOut',
      ].class()}
      style={{
        backgroundImage: 'url(/img/fundo-assinar.webp)',
        backgroundSize: 'cover',
        backgroundRepeat: 'no-repeat',
        backgroundPosition: 'right',
        marginTop: '-130px',
        paddingTop: '130px',
        minHeight: window.innerHeight,
      }}
    >
      <div className="container py-5 h-100">
        <div className="h-100 row justify-content-center align-items-center">
          <BrowserView renderWithFragment>
            <div className="col-md-7">
              <AnimacaoAprender />
            </div>
          </BrowserView>
          <div className="col-sm-6 col-md-4 px-4">
            <div className="w-100 d-flex justify-content-center align-items-center flex-column">
              <div className="bg-white p-4 p-sm-5 rounded w-100">
                <h1 className="mb-4">Entrar</h1>
                <Form onSubmit={enviar} regras={regras}>
                  <Campo
                    name="email"
                    type="email"
                    rotulo="E-mail"
                    prefixar={<Icone nome="envelope-fill" />}
                  />
                  <Campo
                    name="senha"
                    type="password"
                    rotulo="Senha"
                    prefixar={<Icone nome="lock-fill" />}
                  />

                  <Botao>Entrar</Botao>

                  {/* <p className="mt-3 mb-0">
                    É novo por aqui?
                    <Link
                      to="/cadastrar"
                      className="fw-bold text-decoration-none ms-2"
                    >
                      Crie uma conta agora!
                    </Link>
                  </p> */}
                </Form>
              </div>
            </div>
          </div>
          <BrowserView renderWithFragment>
            <div className="col-md-12 mt-5">
              <p className="text-center text-muted mb-0">
                O <strong className="text-primary">Estude+</strong> é um serviço
                de assinatura da{' '}
                <strong className="text-secondary">
                  Faculdade Metropolitana
                </strong>{' '}
                que provê educação para todos por um{' '}
                <strong>preço acessível</strong>.
              </p>
              <p className="text-center text-muted">
                <small>
                  Quer conhecer mais? Crie já sua conta e acesse o Estude+!
                </small>
              </p>
            </div>
          </BrowserView>
        </div>
      </div>
    </div>
  );
};

export default Login;
